import CastleMap from '../components/CastleMap';
import { FINALE_LOCATION } from '../data/enigmas';
import { useProgress } from '../hooks/useProgress';

export default function MapPage() {
  const { remaining, solvedCount, total, allDone } = useProgress();

  if (allDone) {
    return (
      <main className="fh-page fh-page--map">
        <div className="fh-topbar">
          <div className="fh-topbar__main">
            <p className="fh-topbar__label">Festa da História</p>
            <h1 className="fh-topbar__title">Sinal detetado</h1>
            <p className="fh-topbar__hint">
              Toca na localização da Escape Room Bragança
            </p>
          </div>
          <p className="fh-pill">✓</p>
        </div>

        <section className="fh-map-stage" aria-label="Localização final">
          <CastleMap finale={FINALE_LOCATION} showLocate={false} />
        </section>
      </main>
    );
  }

  return (
    <main className="fh-page fh-page--map">
      <div className="fh-topbar">
        <div className="fh-topbar__main">
          <p className="fh-topbar__label">Festa da História</p>
          <h1 className="fh-topbar__title">Mapa do desafio</h1>
          <p className="fh-topbar__hint">Toca na localização para responder</p>
        </div>
        <p className="fh-pill" aria-live="polite">
          {solvedCount}/{total}
        </p>
      </div>

      <section className="fh-map-stage" aria-label="Mapa da cidadela">
        <CastleMap enigmas={remaining} />
      </section>
    </main>
  );
}
